import { ERROR_MESSAGES } from "./constants";
export const isValidLocation = (
  location: { lat?: number; lng?: number } | null
): boolean => {
  if (!location) return false;
  const { lat, lng } = location;
  return (
    lat !== undefined &&
    lng !== undefined &&
    !isNaN(lat) &&
    !isNaN(lng) &&
    isFinite(lat) &&
    isFinite(lng)
  );
};

export interface ResolveLocationParams {
  lat?: number | string | null;
  lon?: number | string | null;
  locationState: { lat?: number; lng?: number } | null;
  allowNull?: boolean;
  errorMessage?: string;
}

export interface ResolveLocationResult {
  lat: number | null;
  lon: number | null;
  error?: string;
}

export const resolveLocation = ({
  lat,
  lon,
  locationState,
  allowNull = false,
  errorMessage,
}: ResolveLocationParams): ResolveLocationResult => {
  const hasProvidedLat = lat !== undefined && lat !== null;
  const hasProvidedLon = lon !== undefined && lon !== null;
  if (hasProvidedLat && hasProvidedLon) {
    const numLat = typeof lat === 'string' ? parseFloat(lat) : lat;
    const numLon = typeof lon === 'string' ? parseFloat(lon) : lon;
    if (!isNaN(numLat) && !isNaN(numLon) && isFinite(numLat) && isFinite(numLon)) {
      return { lat: numLat, lon: numLon };
    }
  }
  if (isValidLocation(locationState)) {
    return {
      lat: locationState!.lat ?? null,
      lon: locationState!.lng ?? null,
    };
  }
  if (!allowNull) {
    return {
      lat: null,
      lon: null,
      error: errorMessage || ERROR_MESSAGES.LOCATION_DATA_REQUIRED,
    };
  }
  return { lat: null, lon: null };
};
